import axios from "axios";
import { API_URL } from "const/constants";
import { referralRequestFromSelection } from "./referralPicker";

const base = (clientId) => `${API_URL}/clients/${clientId}/referrer`;
const unwrap = ({ data }) => data?.data ?? data;

export const getReferrerChangePreview = (clientId) =>
  axios.get(`${base(clientId)}/change-preview`).then(unwrap);

export const changeReferrer = (clientId, body) => axios.post(base(clientId), body).then(unwrap);

export const getReferrerHistory = (clientId) => axios.get(`${base(clientId)}/history`).then(unwrap);

/** The POST body. The expected* fields let the server refuse a change made on a stale preview. */
export const changeRequestBody = ({ selection, clear, mode, reason, preview }) => {
  const picked = clear ? null : referralRequestFromSelection(selection);
  return {
    partnerId: picked?.referralPartnerId ?? null,
    userId: picked?.referralUserId ?? null,
    customLabel: picked?.customReferral ? picked.referral : null,
    clear: !!clear,
    mode: preview?.rowCount > 0 ? mode : null,
    reason: String(reason || "").trim(),
    expectedCurrentPartnerId: preview?.currentPartnerId ?? null,
    expectedCurrentLabel: preview?.currentLabel ?? null,
  };
};

export const apiErrorMessage = (err, fallback) =>
  err?.response?.data?.message || err?.response?.data?.errorMessage || fallback;
